import * as React from 'react';

import { ICheckBoxContainerProps, ICheckBoxContainerState } from './types';

export class CheckBoxContainer extends React.PureComponent<ICheckBoxContainerProps, ICheckBoxContainerState> {

	static defaultProps: Partial<ICheckBoxContainerProps> = {
		isDefaultChecked: false,
	};

	state: ICheckBoxContainerState = {
		isChecked: this.props.isDefaultChecked,
	};

	getCheckedState() {
		if (Object.prototype.hasOwnProperty.call(this.props, 'checked')) {
			return this.props.checked;
		}

		return this.state.isChecked;
	}

	onClick = () => {
		const { onToggle, isDisabled, checked } = this.props;

		if (Object.prototype.hasOwnProperty.call(this.props, 'checked')) {
			onToggle(!checked);

			return;
		}

		if (!isDisabled) {
			this.setState(
				(state: ICheckBoxContainerState) => ({ isChecked: !state.isChecked }),
				() => onToggle(this.state.isChecked),
			);
		}
	};

	render() {
		const { render } = this.props;

		return (
			<div onClick={this.onClick} className={this.props.className}>
				{render({ isChecked: this.getCheckedState() })}
			</div>
		);
	}

}
